import AssessmentRouter from './assessment/Router';
export { getFields } from './assessment/Router';

export default function AssessmentPMRouter(props){
    return <AssessmentRouter {...props} />;
}